module.exports = __webpack_public_path__ + "static/img/preview-4.b5d766a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/preview-4.png
// module id = jgjt
// module chunks = 35